<div class="admin-modal">
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise = !minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">
    <form #templateTypeForm="ngForm" novalidate>

      @if (loading) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
}

      @if (!loading) {
<div>
        <div class="row">
          <div class="col-md-4 text-right">
            <label>Template Type Name</label>
          </div>
          <div class="col-md-5">
            <input type="text" class="form-control" name="template_type_name"
                   placeholder="enter template type name"
                   #templateTypeNameCtrl="ngModel"
                   [(ngModel)]="template_type_data.template_type_name"
                   required />
            @if (templateTypeNameCtrl.invalid && (templateTypeNameCtrl.touched || submitted)) {
<span class="form-error-container"
                 >
              Template Type Name is required.
            </span>
}
          </div>
        </div>

        <div class="row row-spaced">
          <div class="col-md-4 text-right">
            <label>Template Type Description</label>
          </div>
          <div class="col-md-6">
            <textarea class="form-control input-sm"
                      name="template_type_description"
                      [(ngModel)]="template_type_data.template_type_description"
                      placeholder="enter template type description"
                      maxlength="100"></textarea>
          </div>
        </div>

        <div class="row row-spaced">
          <div class="col-md-4 text-right">
            <label>Is Template Type Active :</label>
          </div>
          <div class="col-md-6">
            <input type="checkbox"
                   name="template_type_active"
                   [ngModel]="template_type_data.template_type_active == 1"
                   (ngModelChange)="template_type_data.template_type_active = $event ? 1 : 0"
                   [disabled]="mode === 'new'" />
          </div>
        </div>
      </div>
}

    </form>
  </div>

  <div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-info btn-sm" type="button" (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
    </button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
